export default __webpack_public_path__ + "static/media/comfirmation_failed.89a34d85.svg";